@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: dark from "../../styles/theming.module.css";
}

.hasMedia,
.noMedia {
    composes: root;
}

.noMedia {
    background: linear-gradient(
        180deg,
        rgb(var(--dark-brown-base) / 100%) 0%,
        rgb(var(--true-black-base) / 100%) 100%
    );
}

.overlay {
    &::after {
        content: "";
        position: absolute;
        inset: 0;
        background: var(--overlay-black-56);
    }
}

.promo {
    color: var(--black);

    :is(h1, h2, h3) {
        margin: 0;
        font-size: 72px;
        font-weight: 700;
        letter-spacing: -0.05em;
        line-height: 1;

        @media ($below-mobile) {
            font-size: 48px;
        }
    }

    p {
        margin: -0.25em 0 0;
        font-family: Superior, serif;
        font-size: 36px;
        font-weight: 700;
        letter-spacing: -0.05em;
        color: inherit;

        @media ($below-mobile) {
            margin: 0;
            font-size: 24px;
        }
    }
}

.compact {
    margin-block: var(--spacer-64);
}
